export const ingredients = [
  { name: 'Kaiser Bun', color: 'saddlebrown', type: 'bun' },
  { name: 'Sesame Bun', color: 'sandybrown', type: 'bun' },
  { name: 'Gluten Free Bun', color: 'peru', type: 'bun' },
  { name: 'Lettuce Wrap', color: 'olivedrab', type: 'bun' },
  { name: 'Beef Patty', color: '#3F250B', type: 'patty' },
  { name: 'Soy Patty', color: '#3F250B', type: 'patty' },
  { name: 'Black Bean Patty', color: '#3F250B', type: 'patty' },
  { name: 'Chicken Patty', color: 'burlywood', type: 'patty' },
  { name: 'Lettuce', color: 'lawngreen', type: 'ing' },
  { name: 'Tomato', color: 'tomato', type: 'ing' },
  { name: 'Bacon', color: 'maroon', type: 'ing' },
  { name: 'Onion', color: 'lightyellow', type: 'ing' },
  { name: 'Cheddar Cheese', color: '#FDE18B', type: 'cheese' },
  { name: 'Swiss Cheese', color: '#F1E1A8', type: 'cheese'},
]